module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-1e59d2330b4c6deb84b340635ed36249.ttf";